<template>
  <div>
    <div class="search-bar-margin-bottom-cla">
      <el-form class="search-from-cla" :inline="true" :model="searchFrom">
        <el-form-item :label="$t('apiLog.requestTime')">
          <el-date-picker
            class="pickData_cla"
            v-model="timePick"
            @clear="searchFn"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('pushlog.dataType')">
          <el-select
            class="select-cla"
            v-model="searchFrom.sid"
            clearable
            @clear="searchFn"
            :placeholder="sid"
          >
            <el-option
              v-for="item in sids"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('pushlog.pushResult')">
          <el-select
            @clear="searchFn"
            class="select-cla"
            v-model="searchFrom.result"
            clearable
            :placeholder="result"
          >
            <el-option :label="$t('pushlog.success')" :value="true"></el-option>
            <el-option :label="$t('pushlog.fail')"  :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Mid">
          <el-input
            class="search-input"
            :placeholder="this.$t('apiLog.mid')"
            v-model.trim="searchFrom.mid"
            clearable
            @clear="searchFn"
            @keyup.enter.native="searchFn"
          ></el-input>
        </el-form-item>

        <el-form-item v-if="!isTab" label="AppKey">
          <el-input
            :placeholder="this.$t('apiLog.appKey')"
            v-model.trim="searchFrom.appKey"
            clearable
            @clear="searchFn"
            @keyup.enter.native="searchFn"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchFn" icon="el-icon-search">
            {{ this.$t('common.search') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="black_panel_cla">
      <el-table
        @row-dblclick="dblclick"
        :data="tableData"
        :row-key="getRowKeys"
        style="width: 100%"
      >
        <el-table-column prop="sid" :label="$t('pushlog.dataType')" >
          <template slot-scope="scope">{{
            getSidName(scope.row.sid)
          }}</template>
        </el-table-column>
        <el-table-column prop="mid" label="Mid"></el-table-column>
        <!-- <el-table-column prop="appKey" label="AppKey"></el-table-column> -->
        <el-table-column prop="appName"  :label="$t('apiLog.appName')"></el-table-column>
        <el-table-column prop="pushTime" :label="$t('pushlog.pushTime')">
          <template slot-scope="scope">{{
            scope.row.pushTime | dataFormat('yyyy-MM-dd HH:mm:ss.S')
          }}</template></el-table-column
        >
        <el-table-column :width="90" prop="result" :label="$t('pushlog.pushResult')" >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.result">
              {{ $t('common.success') }}
            </el-tag>
            <el-tag v-else type="danger">
              {{ $t('common.fail') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :width="90" :label="$t('common.action')">
          <template slot-scope="scope">
            <el-button
              class="btn-text-cla"
              @click.stop="detailsFn(scope.row)"
              type="text"
              >{{ $t('common.details') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!listOver && scrollId" class="load-more-cla">
        <el-button
          @click="loadMore"
          :loading="loading"
          class="load-more-btn-cla"
          type="text"
          >{{ $t('com_log.loadMore') }}</el-button
        >
      </div>
    </div>

    <el-drawer :title="$t('pushlog.pushDetails')" :visible.sync="drawer">
      <div style="text-align: right;">
        <el-button
          class="tag-read"
          :data-clipboard-text="JSON.stringify(currentRow)"
          @click="copy"
        >
          {{ $t('apiLog.copy') }}
        </el-button>
      </div>
      <template v-for="item of detailskey">
        <el-row :key="currentRow[item.key]" class="api-row-cla">
          <el-col :span="6"> {{ item.name }}： </el-col>
          <el-col :span="18">
            <json-viewer
              v-if="item.isJson"
              :expand-depth="10"
              :value="currentRow[item.key]"
            ></json-viewer>
            <div v-else>
              <template v-if="item.key === 'result'">
                <el-tag type="success" v-if="currentRow[item.key]">
                  {{ $t('common.success') }}
                </el-tag>
                <el-tag v-else type="danger">
                  {{ $t('common.fail') }}
                </el-tag>
              </template>

              <template v-else-if="item.key === 'sid'">
                {{ getSidName(currentRow[item.key]) }}
              </template>

              <template v-else>
                {{ currentRow[item.key] }}
                <span v-if="item.key === 'elapsedMs'">ms</span>
              </template>
            </div>
          </el-col>
        </el-row>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import pickerOptions from '@/utils/pickerOptions.js'
import { dateFormat, getCurrentDateStartAndEndTime } from '@/utils/utils.js'
import { commonRequest } from '@/services/baseRequst.js'
import JsonViewer from 'vue-json-viewer'
export default {
  props: {
    appKey: {
      type: String,
      default: ''
    },
    isTab: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      timePick: getCurrentDateStartAndEndTime(),
      pickerOptions: pickerOptions(this),
      scrollId: '',
      tableData: [],
      loadingInstance: null,
      listOver: false,
      searchFrom: {
        sid: '',
        appKey: '',
        mid: '',
        result: ''
      },
      currentRow: {},
      drawer: false,
      sids: [
        {
          key: '设备初始化',
          value: 'dse.push.deviceInit'
        },
        {
          key: '设备状态变化',
          value: 'dse.push.deviceStatus'
        },
        {
          key: '生物特征远程登记进度通知',
          value: 'dse.push.registerTipBio'
        },
        {
          key: '生物特征登记通知',
          value: 'dse.push.registerBiometric'
        },
        {
          key: '打卡记录推送',
          value: 'dse.push.punchRecord'
        },
        {
          key: '打卡照片推送',
          value: 'dse.push.punchPhoto'
        },
        {
          key: '门初始化',
          value: 'dse.push.doorInit'
        },
        {
          key: '读头初始化',
          value: 'dse.push.readerInit'
        },
        {
          key: '辅助输入初始化',
          value: 'dse.push.auxInInit'
        },
        {
          key: '辅助输出初始化',
          value: 'dse.push.auxOutInit'
        },
        {
          key: '门禁事件',
          value: 'dse.push.acc.transaction'
        },
        {
          key: '门禁照片',
          value: 'dse.push.acc.verifyPhoto'
        },
        {
          key: '门实时状态',
          value: 'dse.push.acc.realDoorStatus'
        },
        {
          key: this.$t('witnessRecord.personRecord'),
          value: 'dse.push.icc.personVerifyRecord'
        },
        {
          key: this.$t('witnessRecord.checkRecord'),
          value: 'dse.push.icc.verifyRecord'
        },
        {
          key: this.$t('attendanceRecord.verifyPhoto'),
          value: 'dse.push.icc.verifyPhoto'
        }
      ],
      detailskey: [
        {
          key: 'url',
          name: this.$t('apiLog.url')
        },
        {
          key: 'sid',
          name: 'sid'
        },
        {
          key: 'pushType',
          name: 'pushType'
        },
        {
          key: 'appKey',
          name: 'appKey'
        },
        {
          key: 'appName',
          name: 'appName'
        },

        {
          key: 'pushTime',
          name: this.$t('pushlog.pushTime')
        },
        {
          key: 'elapsedMs',
          name: this.$t('apiLog.elapsedMs')
        },

        {
          key: 'result',
          name: this.$t('apiLog.result')
        },
        {
          key: 'mid',
          name: 'mid'
        },
        {
          key: 'requestContent',
          name: this.$t('apiLog.requestContent'),
          isJson: true
        },
        {
          key: 'responseMessage',
          name: this.$t('apiLog.responseMessage'),
          isJson: true
        }
      ]
    }
  },
  mounted() {
    this.searchFn()
  },
  watch: {
    appKey: {
      handler: function(val) {
        this.searchFrom.appKey = val
      },
      immediate: true
    }
  },
  methods: {
    searchFn() {
      let params = {
        lookupFields: {}
      }
      if (this.scrollId) {
        params.lastScrollId = this.scrollId
      }
      if (this.timePick && this.timePick.length === 2) {
        params.startTime = this.timePick[0].getTime()
        params.endTime = this.timePick[1].getTime()
      }
      Object.keys(this.searchFrom).forEach(key => {
        if (this.searchFrom[key] !== '') {
          if (!params.lookupFields) {
            params.lookupFields = {}
          }
          params.lookupFields[key] = this.searchFrom[key]
        }
      })
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      commonRequest('/apiv1/push_log/logs', params)
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.data
            this.tableData = result.logs
            this.scrollId = result.scrollId
            this.listOver = result.listOver
          } else {
            this.errorMessage(data.message)
          }
          this.loadingInstance.close()
        })
        .catch(e => {
          this.loadingInstance.close()
          this.errorMessage(e.message)
        })
    },
    loadMore() {
      this.loading = true
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      commonRequest('/apiv1/push_log/logs', {
        scrollId: this.scrollId
      })
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.data
            this.listOver = result.listOver
            if (!result.listOver) {
              this.tableData.push(...result.logs)
              this.scrollId = result.scrollId
            }
          } else {
            this.errorMessage(data.message)
          }
          this.loading = false
          this.loadingInstance.close()
        })
        .catch(e => {
          this.loading = false
          this.loadingInstance.close()
          this.errorMessage(e.message)
        })
    },
    getRowKeys(row) {
      return row.id
    },
    dblclick(row) {
      this.detailsFn(row)
    },
    convertToJson(str) {
      try {
        let obj = JSON.parse(str)
        if (typeof obj === 'object') {
          return JSON.parse(str, (key, value) => {
            if (key === 'requestTime') {
              return dateFormat(new Date(value), 'yyyy-MM-dd HH:mm:ss.S')
            }
            if (value instanceof Array) {
              return value
            }
            return this.convertToJson(value)
          })
        } else {
          return str
        }
      } catch (error) {
        return str
      }
    },
    detailsFn(row) {
      let temp = JSON.stringify(row)
      let curentRow = this.convertToJson(temp)
      this.currentRow = curentRow
      this.drawer = true
    },
    getSidName(sid) {
      if (!sid) {
        return ''
      }
      let item = this.sids.find(item => {
        return item.value === sid
      })
      return item.key
    }
  },
  components: { JsonViewer }
}
</script>

<style scoped lang="less">
.load-more-cla {
  padding: 5px;
  text-align: center;
  .load-more-btn-cla {
    color: #909399;
    :hover {
      color: #7ace43;
    }
  }
}
/deep/.el-drawer__body {
  margin-bottom: 0px;
  overflow-y: auto;
}

/deep/.el-drawer__header {
  margin-bottom: 0px;
}

.api-row-cla {
  border-bottom: 0.083333rem solid #e3e8ee;
  padding: 5px 15px;
}
.tag-read {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/pushLog.vue